export const buildAiLoginPayload = (email, password) => ({
  email,
  password
});

export const buildAiRegisterPayload = (email, password, fullName) => ({
  email,
  password,
  full_name: fullName
});

export const buildApiKeyPayload = (name) => ({ name });

export const buildAiSubscriptionPayload = (tier, paymentMethodId) => ({
  tier,
  payment_method_id: paymentMethodId
});

export const buildChatCompletionPayload = ({
  messages,
  model = "llama-3.3-70b-versatile",
  temperature = 0.7,
  maxTokens = 20,
  stream = false
}) => ({
  model,
  messages,
  temperature,
  max_tokens: maxTokens,
  stream
});
